import { parseBooleanEnv } from "./env";

export const isFeatureEnabled = (path: string) => {
  path = path.replace(/\-/, "");
  const flag = FEATURE_FLAGS[path];
  return flag !== false;
};

export const FEATURE_FLAGS: {
  [key: string]: boolean;
} = Object.entries(import.meta.env).reduce(
  (flags, [key, value]) => {
    if (key.startsWith("VITE_FEATURE_")) {
      const routePath =
        "/" +
        key.replace("VITE_FEATURE_", "").toLowerCase().replace(/\_/g, "/");
      flags[routePath] = parseBooleanEnv(value as string);
    }
    return flags;
  },
  {} as Record<string, boolean>,
);
